<template>
  <div>
    <div class="main-content">
      <div class="main-content-inner">
        <div class="breadcrumbs ace-save-state" id="breadcrumbs">
          <ul class="breadcrumb">
            <li>
              <i class="ace-icon fa fa-home home-icon"></i>
              <a href="#/">メインメニュー</a>
            </li>
            <router-link tag="li" :to="{ name: 'gates'}">
              <a>ゲート一覧</a>
            </router-link>
            <li class="active">ゲート編集</li>
          </ul><!-- /.breadcrumb -->
        </div>
        <div class="page-header">
          <div class="checkbox">
            <h3>ゲート編集</h3>
          </div>
        </div><!-- /.page-header -->
        <div class="page-content detail-gate-edit">
          <div id="loading" v-if="loading"><div class="loadingMsg"></div></div>
          <div class="tab-content">
          <div class="alert alert-danger" v-if="errorMessageLogs!==''" v-html="errorMessageLogs">
          </div>
          <div class="alert alert-success" v-if="message">
            {{ message }}
          </div>
          <div class="row">
            <div class="col-xs-12">
              <!-- PAGE CONTENT BEGINS -->
              <form class="form-horizontal" role="form">
              <div class="row">
              <div class="col-xs-6">
                <div class="row">
                <div class="profile-user-info profile-user-info-striped">
                  <div class="profile-info-row">
                    <div class="profile-info-name">ゲートID</div>
                    <div class="profile-info-value">
                      <span>{{gateInfor.gateId}}</span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">製品ID</div>
                    <div class="profile-info-value">
                      <span>{{gateInfor.gateModelId}}</span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">製品名</div>
                    <div class="profile-info-value">
                      <span id="product_error" class="error_m"></span>
                      <select class="form-control" data-placeholder="製品名選択" v-model="gateInfor.gateModelId" @change="getGateModelInforWithGateModeId(gateInfor.gateModelId)">
                        <option v-for="(item, index) in listGateModel" v-bind:value="item.gateModelId" v-bind:key="index" v-if="item.makerCode === gateInfor.makerCode">
                          {{item.gateModelName}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">型番</div>
                    <div class="profile-info-value">
                      <span>{{gateInfor.gateModelCode}}</span>
                    </div>
                  </div>
                  <!--<div class="profile-info-row">
                    <div class="profile-info-name">メーカー番号</div>
                    <div class="profile-info-value">
                      <span>{{gateInfor.makerCode}}</span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">変更有無</div>
                    <div class="profile-info-value">
                      <span>{{gateInfor.customizable}}</span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">ターゲット動作設定</div>
                    <div class="profile-info-value">
                      <span>{{gateInfor.target}}</span>
                    </div>
                  </div>-->
                  <div class="profile-info-row" v-if="checkShowHideAdvance(gateInfor.makerCode,gateInfor.customizable)">
                    <div class="profile-info-name">ターゲット動作設定Time</div>
                    <div class="profile-info-value">
                      <input type="number" min="0" max="10000" class="form-control input-sm" v-model="gateInfor.controlTime">
                    </div>
                  </div>
                  <!--<div class="profile-info-row">
                    <div class="profile-info-name">ターゲット動作設定TimeUnit</div>
                    <div class="profile-info-value">
                      <span>{{gateInfor.timeUnit}}</span>
                    </div>
                  </div>-->
                  <div class="profile-info-row">
                    <div class="profile-info-name">ゲート名 <font class="input-required">※必須</font></div>
                    <div class="profile-info-value">
                      <span id="gate_error" v-if="!isGateNameValid" class="error_m">{{gateNameMessage}}</span>
                      <input type="text" v-if="isGateNameValid" class="form-control input-sm" id="gatename" v-model="gateInfor.gateName" @blur="validateBeforeSubmit(1)">
                      <input type="text" v-else class="form-control input-sm error" id="gatename" v-model="gateInfor.gateName" @blur="validateBeforeSubmit(1)">
                    </div>
                  </div>
                  <div class="profile-info-row" v-if="checkShowHide(gateInfor.makerCode, inputIndex.needLocation)">
                    <div class="profile-info-name">位置情報取得</div>
                    <div class="profile-info-value">
                      <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" v-model="gateInfor.needLocation">
                      <span class="lbl"></span>
                    </div>
                  </div>
                  <div class="profile-info-row" v-if="checkShowHide(gateInfor.makerCode, inputIndex.isNFCValid)">
                    <div class="profile-info-name">NFCの有効</div>
                    <div class="profile-info-value">
                      <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" v-model="gateInfor.isNFCValid">
                      <span class="lbl"></span>
                    </div>
                  </div>
                  <div class="profile-info-row" v-if="checkShowHide(gateInfor.makerCode, inputIndex.isTenKeyValid)">
                    <div class="profile-info-name">テンキーの有効・無効</div>
                    <div class="profile-info-value">
                      <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" v-model="gateInfor.isTenKeyValid">
                      <span class="lbl"></span>
                    </div>
                  </div>
                  <div class="profile-info-row" v-if="checkShowHide(gateInfor.makerCode, inputIndex.isGatePasswordValid)">
                    <div class="profile-info-name">ゲートパスワードの有効・無効</div>
                    <div class="profile-info-value">
                      <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" v-model="gateInfor.isGatePasswordValid" :disabled="gateInfor.isVisitor" @change="validateBeforeSubmit(2)">
                      <span class="lbl"></span>
                    </div>
                  </div>
                  <div class="profile-info-row" v-if="checkShowHide(gateInfor.makerCode, inputIndex.gatePasswordLength)">
                    <div class="profile-info-name">ゲートパスワードの桁数</div>
                    <div class="profile-info-value">
                      <select class="form-control" v-model="gateInfor.gatePasswordLength" :disabled="getEditStatus()">
                        <option v-for="item in listPassLenght" v-bind:value="item.value" v-bind:key="item.value">
                          {{item.text}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="profile-info-row" v-if="checkShowHide(gateInfor.makerCode, inputIndex.gatePasswordSeed)">
                    <div class="profile-info-name">ゲートパスワードのseed値</div>
                    <div class="profile-info-value">
                      <span id="passwordseed_error" v-if="!isGatePasswordSeedValid" class="error_m">{{gatePasswordSeedMessage}}</span>
                      <input type="text" v-if="isGatePasswordSeedValid" class="form-control input-sm" id="pseed" v-model="gateInfor.gatePasswordSeed" style="text-transform:uppercase" :disabled="getEditStatus()" @blur="validateBeforeSubmit(2)">
                      <input type="text" v-else class="form-control input-sm error" id="pseed" v-model="gateInfor.gatePasswordSeed" style="text-transform:uppercase" :disabled="getEditStatus()" @blur="validateBeforeSubmit(2)">
                    </div>
                  </div>
                  <div class="profile-info-row" v-if="checkShowHide(gateInfor.makerCode, inputIndex.isTwoStepAuthValid)"> <!--91-->
                    <div class="profile-info-name">2段階認証の有効・無効</div>
                    <div class="profile-info-value">
                      <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" v-model="gateInfor.isTwoStepAuthValid" :disabled="gateInfor.isVisitor || disableTwoStepAuth()">
                      <span class="lbl"></span>
                    </div>
                  </div>
                  <div class="profile-info-row"  v-if="checkShowHide(gateInfor.makerCode, inputIndex.bleIntensity)">
                    <div class="profile-info-name">BLE出力設定</div>
                    <div class="profile-info-value">
                      <select class="form-control" v-model="gateInfor.bleIntensity" v-if="gateInfor.makerCode === 2 || gateInfor.makerCode === 4">
                        <option v-for="item in listBleIntensityForWafer" v-bind:value="item.value" v-bind:key="item.value">
                          {{item.text}}
                        </option>
                      </select>
                      <select class="form-control" v-model="gateInfor.bleIntensity" v-else>
                        <option v-for="item in listBleIntensity" v-bind:value="item.value" v-bind:key="item.value">
                          {{item.text}}
                        </option>
                      </select>
                      <p v-if="gateInfor.makerCode === 2 || gateInfor.makerCode === 4" class="note-text">「とても強い」「強い」に設定した場合、電池の消耗が早くなります。</p>
                    </div>
                  </div>
                  <div class="profile-info-row" v-if="checkShowHide(gateInfor.makerCode, inputIndex.buzzerPattern)"> <!-- 2 and 91-->
                    <div class="profile-info-name">ブザー鳴動設定</div>
                    <div class="profile-info-value">
                      <select class="form-control" v-model="gateInfor.buzzerPattern">
                        <option v-for="item in listBuzzerPattern" v-bind:value="item.value" v-bind:key="item.value">
                          {{item.text}}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                </div>
              </div>
              <div class="col-xs-6">
                <div class="row">
                <div class="profile-user-info profile-user-info-striped">
                  <div class="profile-info-row">
                    <div class="profile-info-name">備考.1</div>
                    <div class="profile-info-value">
                      <span id="option1_error" class="error_m"></span>
                      <textarea class="form-control" id="option1" placeholder="備考.1" v-model="gateInfor.option1" @blur="validateBeforeSubmit(3)"></textarea>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">備考.2</div>
                    <div class="profile-info-value">
                      <span id="option2_error" class="error_m"></span>
                      <textarea class="form-control" id="option2" placeholder="備考.2" v-model="gateInfor.option2" @blur="validateBeforeSubmit(4)"></textarea>
                    </div>
                  </div>
                  <div class="profile-info-row" v-if="checkShowHide(gateInfor.makerCode, inputIndex.gateSNMain)">
                    <div class="profile-info-name">ゲート個体番号1</div>
                    <div class="profile-info-value">
                      <span>{{gateInfor.gateSNMain}}</span>
                    </div>
                  </div>
                  <div class="profile-info-row"  v-if="checkShowHide(gateInfor.makerCode, inputIndex.gateSNBLE)">
                    <div class="profile-info-name">ゲート個体番号2</div>
                    <div class="profile-info-value">
                      <span>{{gateInfor.gateSNBLE}}</span>
                    </div>
                  </div>
                  <div class="profile-info-row" v-if="checkShowHide(gateInfor.makerCode, inputIndex.gateFWMain)"> <!-- 2 and 91-->
                    <div class="profile-info-name">適用されているファームウェアバージョン（メインボード）</div>
                    <div class="profile-info-value">
                      <span>{{gateInfor.gateFWMain}}</span>
                    </div>
                  </div>
                  <div class="profile-info-row" v-if="checkShowHide(gateInfor.makerCode, inputIndex.gateFWBLE)"> <!-- 2 and 91-->
                    <div class="profile-info-name">適用されているファームウェアバージョン（BLE）</div>
                    <div class="profile-info-value">
                      <span>{{gateInfor.gateFWBLE}}</span>
                    </div>
                  </div>
                  <div class="profile-info-row" v-if="checkShowHide(gateInfor.makerCode, inputIndex.registered)">
                    <div class="profile-info-name">登録日</div>
                    <div class="profile-info-value">
                      <span>{{converDate(gateInfor.registered)}}</span>
                    </div>
                  </div>
                  <div class="profile-info-row" v-if="checkShowHide(gateInfor.makerCode, inputIndex.updated)">
                    <div class="profile-info-name">設定更新日</div>
                    <div class="profile-info-value">
                      <span>{{converDate(gateInfor.updated)}}</span>
                    </div>
                  </div>
                  <div class="profile-info-row" v-if="checkShowHide(gateInfor.makerCode, inputIndex.reported)">
                    <div class="profile-info-name">ゲートへ設定情報を適用した日時</div>
                    <div class="profile-info-value">
                      <span>{{converDate(gateInfor.reported)}}</span>
                    </div>
                  </div>
                  <div class="profile-info-row" v-if="checkShowHide(gateInfor.makerCode, inputIndex.revisionDesired)">
                    <div class="profile-info-name">個人コード照合データー：最新リビジョン</div>
                    <div class="profile-info-value">
                      <span>{{gateInfor.revisionDesired}}</span>
                    </div>
                  </div>
                  <div class="profile-info-row" v-if="checkShowHide(gateInfor.makerCode, inputIndex.revisionReported)">
                    <div class="profile-info-name">個人コード照合データー：ゲートへ設定済みのリビジョン</div>
                    <div class="profile-info-value">
                      <span>{{gateInfor.revisionReported}}</span>
                    </div>
                  </div>
                  <div class="profile-info-row" v-if="checkShowHide(gateInfor.makerCode, inputIndex.voltage)">
                    <div class="profile-info-name">電池電圧</div>
                    <div class="profile-info-value">
                      <span>{{gateInfor.voltage}}</span>
                    </div>
                  </div>
                  <div class="profile-info-row" v-if="checkShowHide(gateInfor.makerCode, inputIndex.scanDate)">
                    <div class="profile-info-name">電池電圧更新日</div>
                    <div class="profile-info-value">
                      <span>{{converDate(gateInfor.scanDate)}}</span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">ステータス</div>
                    <div class="profile-info-value">
                      <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" v-model="gateInfor.isValid">
                      <span class="lbl"></span>
                    </div>
                  </div>
                  <div class="profile-info-row" v-if="checkShowAnti()">
                    <div class="profile-info-name">アンチパスバックの有効・無効</div>
                    <div class="profile-info-value">
                      <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" v-model="gateInfor.isAntiPassback" :disabled="disableAntiPass()">
                      <span class="lbl"></span>
                    </div>
                  </div>
                  <div class="profile-info-row" v-if="checkShowAnti()">
                    <div class="profile-info-name">アンチパスバックのモード</div>
                    <div class="profile-info-value">
                      <select id="anti-mode-level" class="form-control" data-placeholder="製品名選択" v-model="gateInfor.antiPassback.mode" :disabled="disableAntiModes()">
                        <option v-for="item in listAntiMode" v-bind:value="item.value" v-bind:key="item.value">
                          {{item.text}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="profile-info-row" v-if="checkShowAnti()">
                    <div class="profile-info-name">アンチパスバックの対向ゲート名</div>
                    <div class="profile-info-value">
                      <span id="anti-gate-name-error" class="error_m"></span>
                      <input type="text" class="form-control input-sm" id="anti-gate-name" v-model="gateInfor.antiPassback.gateName" :disabled="true">
                      <button class="btn btn-info save_group_bottom" type="button" @click="showModalAntiGate()" :disabled="disableAntiModes()">
                        対向ゲートの選択
                      </button>
                    </div>
                  </div>
                </div>
                </div>
              </div>
              </div>
              <div class="form-group">
                <div class="col-sm-12 text-align-right">
                  <router-link :to="{ name: 'gates'}" class="btn cancel_bottom">
                    キャンセル
                  </router-link>
                  <button class="btn btn-info save_group_bottom" type="button" @click="editInforGate">
                    保存
                  </button>
                </div>
              </div>
              <div id="accordion" class="accordion-style1 panel-group">
                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <a class="accordion-toggle" data-toggle="collapse" href="#relation-gate">
                        <i class="bigger-110 ace-icon fa fa-angle-right" data-icon-hide="ace-icon fa fa-angle-down" data-icon-show="ace-icon fa fa-angle-right"></i>
                        &nbsp;ゲートグループ
                      </a>
                    </h4>
                  </div>
                  <div class="panel-collapse collapse" id="relation-gate" aria-expanded="true">
                    <div class="panel-body">
                      <table style="min-width:100%" class="table table-striped table-bordered table-hover dataTable">
                        <thead>
                          <tr>
                            <th class="center" v-if="listGateGroup!=null" style="width:50px!important">
                              <label class="pos-rel">
                                <input type="checkbox" class="ace" v-model="selectAllGate">
                                <span class="lbl"></span>
                              </label>
                            </th>
                            <th>ゲートグループID</th>
                            <th>ゲートグループ名</th>
                            <th class="center">ステータス</th>
                          </tr>
                        </thead>
                        <tbody v-if="listGateGroup!=null">
                          <template v-for="(item, index) in listGateGroup">
                            <tr v-bind:class="{'selected': rowSelectedGate(item.relationId)}" :key="index">
                              <td class="center">
                                <label class="pos-rel">
                                  <input type="checkbox" class="ace" :value="item.relationId" v-model="selectedGateId">
                                  <span class="lbl"></span>
                                </label>
                              </td>
                              <td>{{item.groupId.groupId}}</td>
                              <td>{{item.groupId.name}}</td>
                              <td class="center"><span v-if="item.groupId.isValid">有効</span><span v-else >無効</span></td>
                            </tr>
                          </template>
                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td colspan="3">データーはありません</td>
                          </tr>
                        </tbody>
                      </table>
                      <button class="btn-cus btn-right btn-add" type="button" @click="addGroup(gateInfor.gateId)">
                      ゲートグループの関連付けを追加
                      </button>
                      <a class="btn-cus btn-right btn-delete" href="#processGate" data-toggle="modal" @click="resetStatus()">チェックしたゲートグループの関連付け解除</a>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <a class="accordion-toggle" data-toggle="collapse" href="#passage" aria-expanded="true">
                        <i class="ace-icon fa fa-angle-right bigger-110" data-icon-hide="ace-icon fa fa-angle-down" data-icon-show="ace-icon fa fa-angle-right"></i>
                        &nbsp;期限付きゲートを持つユーザー
                      </a>
                    </h4>
                  </div>
                  <div class="panel-collapse collapse" id="passage">
                    <div class="panel-body">
                      <table style="min-width:100%" class="table table-striped table-bordered table-hover dataTable">
                        <thead>
                          <tr>
                            <th class="center" v-if="listUserGroup != null" style="width:50px!important">
                              <label class="pos-rel">
                                <input type="checkbox" class="ace" v-model="selectAllUser">
                                <span class="lbl"></span>
                              </label>
                            </th>
                            <th>ユーザーID</th>
                            <th>ユーザー名</th>
                            <th>ふりがな</th>
                            <th class="center">ステータス</th>
                            <th class="center">開始日時</th>
                            <th class="center">終了日時</th>
                          </tr>
                        </thead>
                        <tbody v-if="listUserGroup != null">
                          <template v-for="(item, index) in listUserGroup">
                            <tr v-bind:class="{'selected': rowSelected(item.passageId)}" :key="index">
                              <td class="center">
                                <label class="pos-rel">
                                  <input type="checkbox" class="ace" :value="item.passageId" v-model="selectedUserId">
                                  <span class="lbl"></span>
                                </label>
                              </td>
                              <td>{{item.userId.userId}}</td>
                              <td>{{item.userId.name}}</td>
                              <td>{{item.userId.furigana}}</td>
                              <td class="center"><span v-if="item.userId.isValid">有効</span><span v-else >無効</span></td>
                              <td class="center">{{converDate(item.notBefore)}}</td>
                              <td class="center">{{converDate(item.notAfter)}}</td>
                            </tr>
                          </template>
                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td colspan="6">データーはありません</td>
                          </tr>
                        </tbody>
                      </table>
                      <button class="btn-cus btn-right btn-add" type="button" @click="addUser(gateInfor.gateId)">
                      ユーザーの関連付けを追加
                      </button>
                      <a class="btn-cus btn-right btn-delete" href="#process" data-toggle="modal" @click="resetStatus()">チェックしたユーザーの関連付け解除</a>
                    </div>
                  </div>
                </div>
              </div>
              </form>
              <!-- PAGE CONTENT ENDS -->
            </div><!-- /.col -->
          </div><!-- /.row -->
          </div>
        </div><!-- /.page-content -->
      </div>
    </div><!-- /.main-content -->
    <!-- プロフィールModal -->
    <div id="process" class="modal fade" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h3 class="smaller lighter frofile-title no-margin">関連付け解除</h3>
          </div>
          <div class="modal-body">
            <span class="progress-question">このユーザーとの関連付けを解除しますか？</span>
            <div class="progress"  v-bind:class="{'progress-striped':!success , active:!success, hide:!success}">
              <div class="progress-bar" :style="progressWidth">
              <span>{{ Math.round(progress) }}%</span>
              </div>
            </div>
            <span class="success-label" v-if="successUser>0">{{countUser}}件中{{successUser}}件を解除しました。</span>
            <div v-if="errorMessage.length>0">
            <span class="error-box-title">解除失敗</span>
            <div class="error-box">
              <template v-for="item in errorMessage">
                <p v-html="item" :key="item"></p>
              </template>
            </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-sm btn-success pull-right" style="width:100px" data-dismiss="modal" v-if="success">OK</button>
            <button class="btn btn-sm btn-danger pull-right" style="width:100px" v-if="!success" :disabled="isDisabled" @click="deleteRelationUser()">実行</button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div>
    <div id="processGate" class="modal fade" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h3 class="smaller lighter frofile-title no-margin">関連付け解除</h3>
          </div>
          <div class="modal-body">
            <span class="progress-question">このゲートとの関連付けを解除しますか？</span>
            <div class="progress"  v-bind:class="{'progress-striped':!success , active:!success, hide:!success}">
              <div class="progress-bar" :style="progressWidth">
              <span>{{ Math.round(progress) }}%</span>
              </div>
            </div>
            <span class="success-label" v-if="successGate>0">{{countGate}}件中{{successGate}}件を解除しました。</span>
            <div v-if="errorMessage.length>0">
            <span class="error-box-title">解除失敗</span>
            <div class="error-box">
              <template v-for="item in errorMessage">
                <p v-html="item" :key="item"></p>
              </template>
            </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-sm btn-success pull-right" style="width:100px" data-dismiss="modal" v-if="success">OK</button>
            <button class="btn btn-sm btn-danger pull-right" style="width:100px" v-if="!success" :disabled="isDisabled" @click="deleteRelationGate()">実行</button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div>
    <div id="gate-list" class="modal fade" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h3 class="smaller lighter frofile-title no-margin">アンチパスバック対向ゲートの選択</h3>
            <span class="input-icon search-box">
              <input type="text" placeholder="ユーザーID、ユーザー名検索" class="nav-search-input" id="nav-search-input" ref="search_modal" autocomplete="off">
              <i class="ace-icon fa fa-search nav-search-icon"></i>
            </span>
            <button class="btn-cusstom green-btn" type="button" @click="searchGatesForAntipass()">検索</button>
          </div>
          <div class="modal-body">
            <table id="simple-table" class="table  table-bordered table-hover dataTable" v-if="listAntiGates != null && listAntiGates.length > 0">
              <thead>
                <tr>
                  <th></th>
                  <th style="width:150px">ゲートID</th>
                  <th>ゲート名</th>
                </tr>
              </thead>
              <tbody v-for="(item, index) in listAntiGates.slice(firstItemOfCurrentPage, lastItemOfCurrentPage)" :key="index">
                <tr>
                  <td class="center">
                    <label class="pos-rel">
                      <input type="radio" class="ace" :value="item.gateId" v-model="selectedAntiGateId">
                      <span class="lbl"></span>
                    </label>
                  </td>
                  <td style="max-width:150px;word-wrap: break-word">
                    {{item.gateId}}
                  </td>
                  <td style="max-width:150px;word-wrap: break-word">
                    {{item.gateName}}
                  </td>
                </tr>
              </tbody>
            </table>
            <table id="simple-table" class="table  table-bordered table-hover dataTable" v-else>
              <thead>
                <tr>
                  <th style="width:150px">ゲートID</th>
                  <th>ゲート名</th>
                </tr>
              </thead>
              <tbody>
                <tr><td colspan="2">データーはありません</td></tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <div class="row pd-t-10">
              <div class="dataTables_paginate paging_simple_numbers" v-if="countPageAntipassGate>0">
                <paginate ref="gates_paginator"
                  :page-count="countPageAntipassGate"
                  :page-range="3"
                  :margin-pages="2"
                  :click-handler="handleCurrentChange"
                  :prev-text="'<<'"
                  :next-text="'>>'"
                  :container-class="'pagination'"
                  :page-class="'page-item'">
                </paginate>
              </div>
            </div>
            <button class="btn btn-sm btn-danger pull-right" style="width:100px" @click="addAntiGateInfor()" data-dismiss="modal">選択</button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div>
  </div>
</template>

<script>
import * as Config from '../../config'
import moment from 'moment'

export default {
  data () {
    return {
      currentTime: '',
      errorMessageLogs: '',
      selectedUserId: [],
      selectedGateId: [],
      listUserGroup: null,
      listGateGroup: null,
      listIconType: [
        { text: 'ドア', value: 1 },
        { text: 'ロッカー', value: 2 },
        { text: 'その他', value: 0 }

      ],
      listIconTypeForVirtualGate: [
        { text: 'その他', value: 0 }
      ],
      listControlTime: [
        { text: '0000－9999 S', value: 0 },
        { text: '000.0-999.9 S', value: 1 },
        { text: '00.00-99.99 S', value: 2 },
        { text: '0.000-9.999 S', value: 3 }
      ],
      listIsVisitor: [
        { text: 'メンバー', value: false }
      ],
      listBuzzerPattern: [
        { text: 'OFF', value: 0 },
        { text: '鳴動パターン１', value: 1 },
        { text: '鳴動パターン２', value: 2 }
      ],
      listPassLenght: [
        { text: '5桁', value: 5 },
        { text: '6桁', value: 6 },
        { text: '7桁', value: 7 },
        { text: '8桁', value: 8 }
      ],
      listBleIntensity: [
        { text: '非常に強い', value: 0 },
        { text: 'とても強い', value: 1 },
        { text: '強い', value: 2 },
        { text: 'やや強い', value: 3 },
        { text: '普通', value: 4 },
        { text: 'やや弱い', value: 5 },
        { text: '弱い', value: 6 },
        { text: 'とても弱い', value: 7 }
      ],
      listBleIntensityForWafer: [
        { text: 'とても強い', value: 1 },
        { text: '強い', value: 2 },
        { text: 'やや強い', value: 3 },
        { text: '普通', value: 4 },
        { text: 'やや弱い', value: 5 },
        { text: '弱い', value: 6 }
      ],
      listAntiMode: [
        { text: 'ログモード', value: 0 },
        { text: '通行禁止モード', value: 1 }
      ],
      inputIndex: {
        gateName: 1,
        isVisitor: 2,
        isNFCValid: 3,
        isTenKeyValid: 4,
        isGatePasswordValid: 5,
        gatePasswordLength: 6,
        gatePasswordSeed: 7,
        isTwoStepAuthValid: 8,
        bleIntensity: 9,
        buzzerPattern: 10,
        option1: 11,
        option2: 12,
        gateSNMain: 13,
        gateSNBLE: 14,
        gateFWMain: 15,
        gateFWBLE: 16,
        registered: 17,
        updated: 18,
        reported: 19,
        revisionDesired: 20,
        revisionReported: 21,
        voltage: 22,
        scanDate: 23,
        isValid: 24,
        needLocation: 25
      },
      gateInfor: {
        gateId: '',
        gateModelCode: '',
        gateModelName: '',
        gateModelId: '',
        iconType: 0,
        makerCode: '',
        customizable: false,
        target: 0,
        controlTime: 0,
        timeUnit: 0,
        gateName: '',
        isVisitor: false,
        isNFCValid: false,
        isTenKeyValid: false,
        isGatePasswordValid: false,
        gatePasswordLength: 5,
        gatePasswordSeed: '',
        isTwoStepAuthValid: false,
        bleIntensity: 4,
        buzzerPattern: 1,
        option1: '',
        option2: '',
        gateSNMain: '',
        gateSNBLE: '',
        gateFWMain: '',
        gateFWBLE: '',
        registered: '',
        updated: '',
        reported: '',
        revisionDesired: '',
        revisionReported: '',
        voltage: '',
        scanDate: '',
        isValid: true,
        needLocation: true,
        isAntiPassback: false,
        isAntiPassbackPrev: false,
        antiPassback: {
          relationId: 0,
          gateId: '', // デフォルトの値は空欄です
          gateName: '',
          mode: ''
        },
        antiPassbackPrev: {
          relationId: 0,
          gateId: '', // デフォルトの値は空欄です
          gateName: '',
          mode: ''
        }
      },
      gateId: '',
      selectedAntiGateId: '',
      message: '',
      isDisabled: false,
      progress: 0,
      success: false,
      loading: false,
      errorMessage: [],
      successUser: 0,
      successGate: 0,
      errorName: '',
      countUser: 0,
      countGate: 0,
      listGateModel: null,
      exeCountGroup: 0,
      exeCountUser: 0,
      percent: 0,
      isEnabledSave: false, // IF true: Enabled button 保存, false: disabled button 保存
      isGatePasswordSeedValid: true,
      gatePasswordSeedMessage: '',
      isGateNameValid: true,
      gateNameMessage: '',
      allOfFieldIsValid: true,
      listAntiGates: [],
      listAntiGatesDefault: [],
      listAntiGatesFilter: [],
      maxAntipassGateRecord: 0,
      totalPagesAntipassGate: 0,
      countPageAntipassGate: 0,
      antiPassGatePageSize: 25,
      currentPageAntiPassGate: 1,
      firstItemOfCurrentPage: 1,
      lastItemOfCurrentPage: 1
    }
  },
  watch: {
    'gateId': 'fetchData',
    'gateInfor.isVisitor': 'changeValue',
    'gateInfor.isAntiPassback': 'changeIsAntipassback',
    'listAntiGatesDefault': 'bindingListAntiGates',
    'listAntiGates': 'getCountPagesAntiGate',
    'currentPageAntiPassGate': 'getItemIndexOfCurrentPage',
    'progress': 'checkProgress',
    exeCountGroup: function (newVal, oldVal) {
      var vm = this
      if (newVal > 0 && newVal < vm.countGate) {
        vm.deleteGroup(this.selectedGateId[newVal], vm.percent, newVal)
      } else if (newVal > 0 && newVal === vm.countGate) {
        vm.getInforGateGroup(this.gateId)
      }
    },
    exeCountUser: function (newVal, oldVal) {
      var vm = this
      if (newVal > 0 && newVal < vm.countUser) {
        vm.deleteGroupPassage(this.selectedUserId[newVal], vm.percent, newVal)
      } else if (newVal > 0 && newVal === vm.countUser) {
        vm.getInforGatePassage(vm.gateId)
      }
    }
  },
  created () {
    var vm = this
    vm.getGateData()
    vm.getListGateModel()
  },
  mounted () {
    var vm = this
    vm.currentTime = vm.converTimestamp(Date())
    // load anti-passback gate list on popup
    $('#gate-list').on('hidden.bs.modal', this.resetModalGate)
    $('#nav-search-input').keyup(function (e) {
      if (e.keyCode === 13) {
        vm.searchGatesForAntipass()
      }
    })
  },
  computed: {
    progressWidth: function () {
      return 'width:' + this.progress + '%'
    },
    selectAllUser: {
      get: function () {
        return this.listUserGroup ? this.selectedUserId.length === this.listUserGroup.length : false
      },
      set: function (value) {
        var selectedUserId = []
        if (value) {
          this.listUserGroup.forEach(function (item) {
            selectedUserId.push(item.passageId)
          })
        }
        this.selectedUserId = selectedUserId
      }
    },
    selectAllGate: {
      get: function () {
        return this.listGateGroup ? this.selectedGateId.length === this.listGateGroup.length : false
      },
      set: function (value) {
        var selectedGateId = []
        if (value) {
          this.listGateGroup.forEach(function (item) {
            selectedGateId.push(item.relationId)
          })
        }
        this.selectedGateId = selectedGateId
      }
    }
  },
  methods: {
    checkShowHide (makerCode, inputIndex) {
      inputIndex = inputIndex || -1
      switch (inputIndex) {
        case this.inputIndex.isTwoStepAuthValid:
          if (makerCode === 91) {
            return false
          } else {
            return true
          }
        case this.inputIndex.bleIntensity:
          if (makerCode === 91) {
            return false
          } else {
            return true
          }
        case this.inputIndex.buzzerPattern:
          if (makerCode === 91 || makerCode === 2 || makerCode === 4) {
            return false
          } else {
            return true
          }
        case this.inputIndex.gateSNMain:
          if (makerCode === 91) {
            return false
          } else {
            return true
          }
        case this.inputIndex.gateSNBLE:
          if (makerCode === 91) {
            return false
          } else {
            return true
          }
        case this.inputIndex.gateFWMain:
          if (makerCode === 91 || makerCode === 2 || makerCode === 4) {
            return false
          } else {
            return true
          }
        case this.inputIndex.gateFWBLE:
          if (makerCode === 91 || makerCode === 2 || makerCode === 4) {
            return false
          } else {
            return true
          }
        case this.inputIndex.registered:
          if (makerCode === 91) {
            return false
          } else {
            return true
          }
        case this.inputIndex.updated:
          if (makerCode === 91) {
            return false
          } else {
            return true
          }
        case this.inputIndex.reported:
          if (makerCode === 91) {
            return false
          } else {
            return true
          }
        case this.inputIndex.revisionDesired:
          if (makerCode === 91) {
            return false
          } else {
            return true
          }
        case this.inputIndex.revisionReported:
          if (makerCode === 91) {
            return false
          } else {
            return true
          }
        case this.inputIndex.voltage:
          if (makerCode === 91) {
            return false
          } else {
            return true
          }
        case this.inputIndex.scanDate:
          if (makerCode === 91) {
            return false
          } else {
            return true
          }
        case this.inputIndex.isVisitor:
          if (makerCode === 91 || makerCode === 2 || makerCode === 4) {
            return false
          } else {
            return true
          }
        case this.inputIndex.isNFCValid:
          if (makerCode === 91 || makerCode === 2 || makerCode === 4) {
            return false
          } else {
            return true
          }
        case this.inputIndex.isTenKeyValid:
          if (makerCode === 91 || makerCode === 2 || makerCode === 4) {
            return false
          } else {
            return true
          }
        case this.inputIndex.isGatePasswordValid:
          if (makerCode === 91 || makerCode === 2 || makerCode === 4) {
            return false
          } else {
            return true
          }
        case this.inputIndex.gatePasswordLength:
          if (makerCode === 91 || makerCode === 2 || makerCode === 4) {
            return false
          } else {
            return true
          }
        case this.inputIndex.gatePasswordSeed:
          if (makerCode === 91 || makerCode === 2 || makerCode === 4) {
            return false
          } else {
            return true
          }
        case this.inputIndex.needLocation:
          if (makerCode !== 91) {
            return false
          } else {
            return true
          }
        default:
          if (makerCode === 2 || makerCode === 4) {
            return false
          } else {
            return true
          }
      }
    },
    checkShowHideAdvance (makerCode, customizable) {
      if (makerCode === 2 || makerCode === 91 || makerCode === 4) {
        return false
      } else {
        if (customizable) {
          return true
        } else {
          return false
        }
      }
    },
    checkShowAnti () {
      // only show Anti-pass when makercode is ALLIGATE (=1) and is not visitor
      if (!this.gateInfor.isVisitor) {
        if (this.gateInfor.makerCode === 1 && (this.gateInfor.target === 1 || this.gateInfor.target === 5)) {
          // markercode is ALLIGATE and target is ALLIGATE I/O (not Logger)
          return true
        }
        // markercode is not ALLIGATE, it is able to be WaferLock => Anti-pass is resetted (inactive)
        this.gateInfor.isAntiPassback = false
      }
      return false
    },
    changeIsAntipassback () {
      if (this.gateInfor.isAntiPassback) {
        if (this.gateInfor.isAntiPassbackPrev) {
          this.gateInfor.antiPassback.gateId = this.gateInfor.antiPassbackPrev.gateId // デフォルトの値は空欄です
          this.gateInfor.antiPassback.gateName = this.gateInfor.antiPassbackPrev.gateName // デフォルトの値は空欄です
          this.gateInfor.antiPassback.mode = this.gateInfor.antiPassbackPrev.mode // デフォルトの値は空欄です
          this.selectedAntiGateId = this.gateInfor.antiPassbackPrev.gateId // デフォルトの値は空欄です
        } else {
          this.gateInfor.antiPassback.mode = 0
        }
      }
      this.validateBeforeSubmit(4)
    },
    disableAntiPass () {
      // this method uses to inactive and disable anti-pass when two-step-auth field is actived
      if (this.gateInfor.isTwoStepAuthValid) {
        this.gateInfor.isAntiPassback = false
      }
      return this.gateInfor.isTwoStepAuthValid
    },
    disableTwoStepAuth () {
      // this method uses to inactive and disable two step field when anti-pass is actived
      if (this.gateInfor.isAntiPassback) {
        // if anti-pass is actived then inactive and disable two-step-auth field
        this.gateInfor.isTwoStepAuthValid = false
      }
      return this.gateInfor.isAntiPassback
    },
    disableAntiModes () {
      // this method uses to check and enable/disable anti modes (level, gate name)
      if (!this.gateInfor.isAntiPassback) {
        // if anti-pass not enable then reset anti modes
        this.gateInfor.antiPassback.gateId = '' // デフォルトの値は空欄です
        this.gateInfor.antiPassback.gateName = '' // デフォルトの値は空欄です
        this.gateInfor.antiPassback.mode = '' // デフォルトの値は空欄です
        this.selectedAntiGateId = '' // デフォルトの値は空欄です
      }
      return !this.gateInfor.isAntiPassback
    },
    converTimestamp (t) {
      return parseInt(new Date(t) / 1000)
    },
    changeValue () {
      if (this.gateInfor.isVisitor) {
        this.gateInfor.isGatePasswordValid = false
        this.gateInfor.isTwoStepAuthValid = false
        this.gateInfor.isAntiPassback = false
      }
    },
    getEditStatus () {
      if (!this.gateInfor.isGatePasswordValid || this.gateInfor.isVisitor) {
        return true
      } else {
        return false
      }
    },
    validateBeforeSubmit (index) {
      this.allOfFieldIsValid = true
      if (this.gateInfor.gateModelId === null || this.gateInfor.gateModelId === '') {
        if (index === 0 || index === -1) {
          $('#product_error').html('製品名は必須です。')
          $('#productname').addClass('error')
        }
        this.allOfFieldIsValid = false
      } else {
        if (index === 0 || index === -1) {
          $('#product_error').html('')
          $('#productname').removeClass('error')
        }
      }
      if (this.gateInfor.gateName === null || this.gateInfor.gateName === '') {
        // gate name is required
        if (index === 1 || index === -1) {
          $('#gate_error').html('ゲート名は必須です。')
          $('#gatename').addClass('error')
          this.isGateNameValid = false
          this.gateNameMessage = 'ゲート名は必須です。'
        }
        this.allOfFieldIsValid = false
      } else {
        if (this.gateInfor.gateName.length > 64) {
          // gate Name > 64 chars
          if (index === 1 || index === -1) {
            $('#gate_error').html('ゲート名は64文字以内で入力してください。')
            $('#gatename').addClass('error')
            this.isGateNameValid = false
            this.gateNameMessage = 'ゲート名は64文字以内で入力してください。'
          }
          this.allOfFieldIsValid = false
        } else {
          // reset message
          if (index === 1 || index === -1) {
            $('#gate_error').html('')
            $('#gatename').removeClass('error')
            this.isGateNameValid = true
            this.gateNameMessage = ''
          }
        }
      }
      var isOk = /^[0-9a-fA-F]+$/.test(this.gateInfor.gatePasswordSeed)
      if (!isOk || this.gateInfor.gatePasswordSeed.length > 18 || this.gateInfor.gatePasswordSeed.length < 18) {
        if (index === 2 || index === -1) {
          $('#passwordseed_error').html('半角英数（0～9、A〜F）で18文字入力してください。')
          $('#pseed').addClass('error')
          this.isGatePasswordSeedValid = false
          this.gatePasswordSeedMessage = '半角英数（0～9、A〜F）で18文字入力してください。'
        }
        this.allOfFieldIsValid = false
      } else {
        if (index === 2 || index === -1) {
          $('#passwordseed_error').html('')
          $('#pseed').removeClass('error')
          this.isGatePasswordSeedValid = true
          this.gatePasswordSeedMessage = ''
        }
      }
      if (this.gateInfor.option1 !== null && this.gateInfor.option1 !== '') {
        if (this.gateInfor.option1.length > 64) {
          if (index === -1 || index === 3) {
            $('#option1_error').html('備考は64文字以内で入力してください。')
            $('#option1').addClass('error')
          }
          this.allOfFieldIsValid = false
        } else {
          if (index === -1 || index === 3) {
            $('#option1_error').html('')
            $('#option1').removeClass('error')
          }
        }
      } else {
        // if option 1 is not input
        if (index === -1 || index === 3) {
          $('#option1_error').html('')
          $('#option1').removeClass('error')
        }
      }
      if (this.gateInfor.option2 !== null && this.gateInfor.option2 !== '') {
        if (this.gateInfor.option2.length > 64) {
          if (index === -1 || index === 4) {
            $('#option2_error').html('備考は64文字以内で入力してください。')
            $('#option2').addClass('error')
          }
          this.allOfFieldIsValid = false
        } else {
          if (index === -1 || index === 4) {
            $('#option2_error').html('')
            $('#option2').removeClass('error')
          }
        }
      } else {
        // if option 2 is not input
        if (index === -1 || index === 4) {
          $('#option2_error').html('')
          $('#option2').removeClass('error')
        }
      }
      if (this.gateInfor.isAntiPassback === true) {
        // anti-pass is actived
        if (this.gateInfor.antiPassback.gateId.trim() === '') {
          if (index === 3 || index === -1) {
            $('#anti-gate-name-error').html('対向ゲートを選択してください')
            $('#anti-gate-name').addClass('error')
          }
          this.allOfFieldIsValid = false
        } else {
          if (index === 3 || index === -1) {
            $('#anti-gate-name-error').html('')
            $('#anti-gate-name').removeClass('error')
          }
        }
      } else {
        if (index === 4 || index === 3 || index === -1) {
          $('#anti-gate-name-error').html('')
          $('#anti-gate-name').removeClass('error')
        }
      }
      this.isEnabledSave = this.allOfFieldIsValid
    },
    converDate (t) {
      return moment(new Date(t * 1000)).format('YYYY/MM/DD H:mm')
    },
    getListGateModel () {
      this.$http.get(Config.GATE_MODEL_LIST_API)
        .then(response => {
          console.log(response)
          this.listGateModel = response.body.gateModels
        })
        .catch((error) => {
          this.listGateModel = null
          console.log(error)
        })
    },
    checkProgress () {
      if (Math.round(this.progress) === 100) {
        this.success = true
        this.selectedUserId = []
        this.selectedGateId = []
      }
    },
    resetStatus () {
      $('.progress').addClass('hide')
      $('.progress-question').html('このユーザーとの関連付けを解除しますか？')
      this.progress = 0
      this.success = false
      this.isDisabled = false
      this.errorMessage = []
      this.successUser = 0
      this.successGate = 0
      this.countUser = 0
      this.countGate = 0
      this.exeCountUser = 0
      this.exeCountGroup = 0
    },
    rowSelected (userId) {
      if (jQuery.inArray(userId, this.selectedUserId) !== -1) {
        return true
      } else {
        return false
      }
    },
    rowSelectedGate (userId) {
      if (jQuery.inArray(userId, this.selectedGateId) !== -1) {
        return true
      } else {
        return false
      }
    },
    fetchData () {
      this.getInforGateGroup(this.gateId)
      this.getInforGatePassage(this.gateId)
    },
    getGroupInfo (groupId, gateId, i) {
      var vm = this
      this.$http.get(Config.GROUPS_LIST_API + '?groupId=' + encodeURIComponent(groupId))
        .then(response => {
          vm.listGateGroup[i].groupId = response.body.groups[0]
        })
        .catch(error => {
          console.log(error)
        })
    },
    getInforGateGroup (gateId) {
      var vm = this
      this.$http.get(Config.RELATION_GATE_GROUP_API + '?gateId=' + encodeURIComponent(gateId))
        .then(response => {
          vm.listGateGroup = response.body.relationsGateGroup
          if (vm.listGateGroup.length > 0) {
            for (var i = 0; i < vm.listGateGroup.length; i++) {
              vm.getGroupInfo(vm.listGateGroup[i].groupId, vm.listGateGroup[i].gateId, i)
            }
          } else {
            vm.listGateGroup = null
          }
        })
        .catch((error) => {
          vm.listGateGroup = null
          console.log(error)
        })
    },
    getInforUser (gateId, userId, i) {
      var vm = this
      this.$http.get(Config.USERS_LIST_API + '?userId=' + encodeURIComponent(userId))
        .then(response => {
          vm.listUserGroup[i].userId = response.body.users[0]
        })
        .catch(error => {
          console.log(error)
        })
    },
    getInforGatePassage (gateId) {
      var vm = this
      this.$http.get(Config.GATES_PASSAGE_API + '?gateId=' + encodeURIComponent(gateId) + '&notBefore=' + vm.currentTime)
        .then(response => {
          console.log(response)
          if (response.body.maxRecords > 0) {
            vm.listUserGroup = response.body.passages
            for (var i = 0; i < vm.listUserGroup.length; i++) {
              vm.getInforUser(vm.listUserGroup[i].gateId, vm.listUserGroup[i].userId, i)
            }
          } else {
            vm.listUserGroup = null
          }
        })
        .catch((error) => {
          console.log(error)
          vm.listUserGroup = null
        })
    },
    getGateData () {
      var vm = this
      vm.errorMessageLogs = ''
      var data = this.$route.query
      this.gateId = data.id
      this.$http.get(Config.GATES_LIST_API + '?gateId=' + encodeURIComponent(vm.gateId))
        .then(response => {
          console.log(response)
          vm.gateInfor.gateId = response.body.gates[0].gateId
          vm.gateInfor.gateModelCode = response.body.gates[0].gateModelCode
          vm.gateInfor.gateModelName = response.body.gates[0].gateModelName
          vm.gateInfor.gateModelId = response.body.gates[0].gateModelId
          vm.gateInfor.iconType = response.body.gates[0].iconType
          vm.gateInfor.makerCode = response.body.gates[0].makerCode
          vm.gateInfor.customizable = response.body.gates[0].customizable
          vm.gateInfor.target = response.body.gates[0].target
          vm.gateInfor.controlTime = response.body.gates[0].controlTime
          vm.gateInfor.timeUnit = response.body.gates[0].timeUnit
          vm.gateInfor.gateName = response.body.gates[0].gateName
          vm.gateInfor.isVisitor = response.body.gates[0].isVisitor
          vm.gateInfor.isNFCValid = response.body.gates[0].isNFCValid
          vm.gateInfor.isTenKeyValid = response.body.gates[0].isTenKeyValid
          vm.gateInfor.isGatePasswordValid = response.body.gates[0].isGatePasswordValid
          vm.gateInfor.gatePasswordLength = response.body.gates[0].gatePasswordLength
          vm.gateInfor.gatePasswordSeed = response.body.gates[0].gatePasswordSeed
          vm.gateInfor.isTwoStepAuthValid = response.body.gates[0].isTwoStepAuthValid
          vm.gateInfor.bleIntensity = response.body.gates[0].bleIntensity
          vm.gateInfor.buzzerPattern = response.body.gates[0].buzzerPattern
          vm.gateInfor.option1 = response.body.gates[0].option1
          vm.gateInfor.option2 = response.body.gates[0].option2
          vm.gateInfor.gateSNMain = response.body.gates[0].gateSNMain
          vm.gateInfor.gateSNBLE = response.body.gates[0].gateSNBLE
          vm.gateInfor.gateFWMain = response.body.gates[0].gateFWMain
          vm.gateInfor.gateFWBLE = response.body.gates[0].gateFWBLE
          vm.gateInfor.registered = response.body.gates[0].registered
          vm.gateInfor.updated = response.body.gates[0].updated
          vm.gateInfor.reported = response.body.gates[0].reported
          vm.gateInfor.revisionDesired = response.body.gates[0].revisionDesired
          vm.gateInfor.revisionReported = response.body.gates[0].revisionReported
          vm.gateInfor.voltage = response.body.gates[0].voltage
          vm.gateInfor.scanDate = response.body.gates[0].scanDate
          vm.gateInfor.isValid = response.body.gates[0].isValid
          vm.gateInfor.needLocation = response.body.gates[0].needLocation
          vm.gateInfor.isAntiPassback = response.body.gates[0].isAntiPassback
          vm.gateInfor.isAntiPassbackPrev = response.body.gates[0].isAntiPassback
          if (vm.gateInfor.isAntiPassback === true) {
            this.setAntiPassData(response.body.gates[0].antiPassback)
            this.selectedAntiGateId = response.body.gates[0].antiPassback.gateId
          }
          this.validateBeforeSubmit(0)
        })
        .catch(error => {
          switch (error.status) {
            case 401:
              if (error.body.message === 'The incoming token has expired') {
                this.errorMessageLogs = ''
              } else {
                this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              }
              break
            case 400:
              this.errorMessageLogs = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              break
            case 403:
              this.errorMessageLogs = 'ゲートの取得権限がありません。'
              break
            case 404:
              this.errorMessageLogs = '該当するデーターがありません。'
              break
            case 500:
              this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
          }
        })
    },
    setAntiPassData (antiPassback) {
      var vm = this
      vm.gateInfor.antiPassback.relationId = antiPassback.relationId
      vm.gateInfor.antiPassback.gateId = antiPassback.gateId
      vm.gateInfor.antiPassback.gateName = antiPassback.gateName
      vm.gateInfor.antiPassback.mode = antiPassback.mode
      // antiPassbackPrev is the backuped object
      vm.gateInfor.antiPassbackPrev.relationId = antiPassback.relationId
      vm.gateInfor.antiPassbackPrev.gateId = antiPassback.gateId
      vm.gateInfor.antiPassbackPrev.gateName = antiPassback.gateName
      vm.gateInfor.antiPassbackPrev.mode = antiPassback.mode
    },
    getGateModelInforWithGateModeId (gateModelId) {
      var vm = this
      vm.listGateModel.forEach(function (item) {
        if (item.gateModelId === gateModelId) {
          vm.gateInfor.gateModelCode = item.gateModelCode
          vm.gateInfor.gateModelName = item.gateModelName
          vm.gateInfor.controlTime = item.controlTime
          vm.gateInfor.makerCode = item.makerCode
          vm.gateInfor.customizable = item.customizable
          vm.gateInfor.iconType = item.iconType
          vm.gateInfor.target = item.target
          vm.gateInfor.timeUnit = item.timeUnit
        }
      })

      this.validateBeforeSubmit(0)
    },
    editInforGate () {
      this.validateBeforeSubmit(-1)
      if (this.allOfFieldIsValid) {
        var vm = this
        vm.loading = true
        this.message = ''
        this.errorMessageLogs = ''
        const Infor = {
          gateName: vm.gateInfor.gateName,
          gateModelId: vm.gateInfor.gateModelId,
          gateModelName: vm.gateInfor.gateModelName,
          gateModelCode: vm.gateInfor.gateModelCode,
          iconType: vm.gateInfor.iconType,
          customizable: vm.gateInfor.customizable,
          makerCode: vm.gateInfor.makerCode,
          target: vm.gateInfor.target,
          timeUnit: vm.gateInfor.timeUnit,
          controlTime: parseInt(vm.gateInfor.controlTime),
          isVisitor: vm.gateInfor.isVisitor,
          isNFCValid: vm.gateInfor.isNFCValid,
          isTenKeyValid: vm.gateInfor.isTenKeyValid,
          isGatePasswordValid: vm.gateInfor.isGatePasswordValid,
          gatePasswordLength: vm.gateInfor.gatePasswordLength,
          gatePasswordSeed: vm.gateInfor.gatePasswordSeed,
          isTwoStepAuthValid: vm.gateInfor.isTwoStepAuthValid,
          bleIntensity: vm.gateInfor.bleIntensity,
          buzzerPattern: vm.gateInfor.buzzerPattern,
          option1: vm.gateInfor.option1,
          option2: vm.gateInfor.option2,
          isValid: vm.gateInfor.isValid,
          needLocation: vm.gateInfor.needLocation
        }
        console.log(Infor)
        this.$http.put(Config.GATES_LIST_API + '/' + encodeURIComponent(vm.gateId), Infor)
          .then(response => {
            // call to anti-pass update API
            this.updateAntiPassGate()
          })
          .catch((error) => {
            this.message = ''
            this.loading = false
            switch (error.status) {
              case 401:
                if (error.body.message === 'The incoming token has expired') {
                  this.errorMessageLogs = ''
                } else {
                  this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                }
                break
              case 400:
                this.errorMessageLogs = '入力したパラメーターが誤っています。入力内容をご確認ください。'
                break
              case 403:
                this.errorMessageLogs = 'ゲートの編集権限がありません。'
                break
              case 404:
                this.errorMessageLogs = '該当するデーターがありません。'
                break
              case 409:
                this.errorMessageLogs = '入力されたゲート名は既に使用されています。他のゲート名を入力してください。'
                break
              case 500:
                this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                break
              case 503:
                this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                break
              default:
                this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                break
            }
          })
      }
    },
    addGroup (gateId) {
      this.$router.push({name: 'gategroupadd', query: { id: gateId }})
    },
    addUser (gateId) {
      this.$router.push({name: 'gateuseradd', query: { id: gateId }})
    },
    deleteGroupPassage (passageId, percent, i) {
      var vm = this
      this.$http.delete(Config.GATES_PASSAGE_API + '/' + encodeURIComponent(passageId))
        .then(response => {
          vm.progress += percent
          vm.successUser += 1
          vm.exeCountUser++
        })
        .catch((error) => {
          vm.getInforGatePassage(vm.gateId)
          vm.progress += percent
          switch (error.status) {
            case 401:
              if (error.body.message === 'The incoming token has expired') {
                this.errorName = ''
              } else {
                this.errorName = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              }
              break
            case 403:
              this.errorName = '期間指定の通行権限の削除権限がありません。'
              break
            case 404:
              this.errorName = '該当するデーターがありません。'
              break
            case 500:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
          }
          var rowstatus = passageId + '>><span>' + this.errorName + '</span>'
          this.$set(this.errorMessage, i, rowstatus)
          this.exeCountUser++
        })
    },
    deleteRelationUser () {
      var vm = this
      vm.isDisabled = true
      if (this.selectedUserId.length > 0) {
        this.countUser = this.selectedUserId.length
        $('.progress').removeClass('hide')
        $('.progress-question').html('処理状況')
        vm.percent = (100 / this.selectedUserId.length)
        vm.deleteGroupPassage(this.selectedUserId[0], vm.percent, 0)
      } else {
        alert('少なくてもユーザーを１つ選んでください。')
      }
    },
    deleteGroup (relationId, percent, i) {
      this.$http.delete(Config.RELATION_GATE_GROUP_API + '/' + encodeURIComponent(relationId))
        .then(response => {
          this.progress += percent
          this.successGate += 1
          this.exeCountGroup++
        })
        .catch((error) => {
          this.getInforGateGroup(this.gateId)
          this.progress += percent
          switch (error.status) {
            case 401:
              if (error.body.message === 'The incoming token has expired') {
                this.errorName = ''
              } else {
                this.errorName = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              }
              break
            case 403:
              this.errorName = 'ゲート通行権限の削除権限がありません。'
              break
            case 404:
              this.errorName = '該当するデーターがありません。'
              break
            case 500:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
          }
          var rowstatus = relationId + '>><span>' + this.errorName + '</span>'
          this.$set(this.errorMessage, i, rowstatus)
          this.exeCountGroup++
        })
    },
    deleteRelationGate () {
      var vm = this
      vm.isDisabled = true
      if (this.selectedGateId.length > 0) {
        this.countGate = this.selectedGateId.length
        $('.progress').removeClass('hide')
        $('.progress-question').html('処理状況')
        vm.percent = (100 / this.selectedGateId.length)
        vm.deleteGroup(this.selectedGateId[0], vm.percent, 0)
      } else {
        alert('少なくてもゲートを１つ選んでください。')
      }
    },
    setDefaultCurPage (curPage) {
      if (this.$refs.gates_paginator) {
        // the selected is started from 0
        this.$refs.gates_paginator.selected = curPage
      }
    },
    resetModalGate () {
      $('#nav-search-input').val('')
      this.listAntiGates = []
      this.listAntiGatesDefault = []
      this.listAntiGatesFilter = []
      this.maxAntipassGateRecord = 0
      this.totalPagesAntipassGate = 0
      this.countPageAntipassGate = 0
      this.antiPassGatePageSize = 25
      this.currentPageAntiPassGate = 1
      this.firstItemOfCurrentPage = 1
      this.lastItemOfCurrentPage = 1
      this.setDefaultCurPage(0)
    },
    showModalAntiGate () {
      this.loadGatesForAntipass()
      $('#gate-list').modal({
        backdrop: 'static',
        keyboard: false
      })
    },
    addAntiGateInfor () {
      var vm = this
      if (this.selectedAntiGateId !== null && this.selectedAntiGateId.trim().length > 0) {
        this.$http.get(Config.GATES_LIST_API + '?gateId=' + encodeURIComponent(this.selectedAntiGateId))
          .then(response => {
            vm.gateInfor.antiPassback.gateId = response.body.gates[0].gateId
            vm.gateInfor.antiPassback.gateName = response.body.gates[0].gateName
            // 3: validate antipass
            vm.validateBeforeSubmit(3)
          })
          .catch(error => {
            console.log(error)
            // 3: validate antipass
            vm.validateBeforeSubmit(3)
          })
      } else {
        // 3: validate antipass
        vm.validateBeforeSubmit(3)
      }
    },
    handleCurrentChange (val) {
      this.currentPageAntiPassGate = val
    },
    loadGatesForAntipass () {
      console.log('start:' + this.second)
      this.interval = setInterval(this.cal, 1000)
      this.loading = true
      var pageIndex = 1
      var pageSize = 1000
      // get 1000 first record (page 1)
      this.getGatesForAntipass(pageIndex, pageSize)
    },
    bindingListAntiGates () {
      this.listAntiGates = []
      this.listAntiGates = this.listAntiGatesDefault
    },
    getCountPagesAntiGate () {
      var countAntiGatesInList = this.listAntiGates.length
      this.countPageAntipassGate = Math.ceil(countAntiGatesInList / this.antiPassGatePageSize)
      this.getItemIndexOfCurrentPage()
    },
    getItemIndexOfCurrentPage () {
      this.firstItemOfCurrentPage = (this.currentPageAntiPassGate - 1) * this.antiPassGatePageSize
      this.lastItemOfCurrentPage = (this.firstItemOfCurrentPage + this.antiPassGatePageSize)
    },
    searchGatesForAntipass () {
      var vm = this
      vm.listAntiGates = []
      vm.currentPageAntiPassGate = 1
      this.setDefaultCurPage(0)
      if (vm.listAntiGatesDefault !== null && vm.listAntiGatesDefault.length > 0) {
        var keyword = $('#nav-search-input').val()
        // keyword = keyword.replace(/\s/g, '')
        if (keyword !== null && keyword.trim().length > 0) {
          vm.listAntiGatesDefault.forEach(function (item) {
            if (item.gateId.indexOf(keyword) !== -1 ||
                item.gateName.indexOf(keyword) !== -1 ||
                item.gateId === keyword ||
                item.gateName === keyword) {
              vm.listAntiGates.push(item)
            }
          })
          console.log(vm.listAntiGates)
        } else {
          vm.listAntiGates = vm.listAntiGatesDefault
        }
      }
    },
    getGatesForAntipass (pageIndex, pageSize) {
      var vm = this
      this.$http.get(Config.GATES_LIST_API + '?limit=' + pageSize + '&page=' + pageIndex + '&keyword=' + '&scorp=gateId,gateName' + '&sortKey=desc:registered&isValid=true')
        .then(response => {
          vm.maxAntipassGateRecord = response.body.maxRecords
          if (vm.maxAntipassGateRecord > 0) {
            response.body.gates.forEach(function (item) {
              if ((item.isAntiPassback === false || item.gateId === vm.gateInfor.antiPassbackPrev.gateId) && vm.gateInfor.gateId !== item.gateId &&
                  item.makerCode === 1 && (item.target === 1 || item.target === 5) && !item.isVisitor && !item.isTwoStepAuthValid) {
                vm.listAntiGatesDefault.push(item)
              }
            })
            if (pageIndex === 1) {
              // set current page is 0 (page 1)
              this.setDefaultCurPage(0)
            }
            // calculate total page of all records (all records are returned from API)
            vm.totalPagesAntipassGate = Math.ceil((vm.maxAntipassGateRecord) / pageSize)
            if (vm.totalPagesAntipassGate > pageIndex) {
              // continue get gates from API (get more 1000 next record)
              vm.getGatesForAntipass(pageIndex + 1, pageSize)
            } else if (vm.totalPagesAntipassGate === pageIndex) {
              // the current page is the last page
              this.loading = false
              clearInterval(this.interval)
              console.log('end:' + this.second)
            }
          } else {
            this.loading = false
            clearInterval(this.interval)
            console.log('end:' + this.second)
          }
        })
        .catch((error) => {
          if (vm.totalPagesAntipassGate === pageIndex) {
            // the current page is the last page
            this.loading = false
          }
          console.log(error)
        })
    },
    updateAntiPassGate () {
      this.errorMessageLogs = ''
      if (!this.gateInfor.isAntiPassbackPrev) {
        // if the prev anti-pass infor is in-actived
        if (this.gateInfor.isAntiPassback === true) {
          // the new anti-pass infor is actived, then call to anti-pass insert API
          this.createAntiPassGate(this.gateId)
        } else {
          this.loading = false
          this.message = Config.EDIT_GATE_API_SUCCESS
          this.errorMessageLogs = ''
          window.scrollTo(0, 0)
        }
      } else {
        // if the prev anti-pass infor is active, then calling anti-pass delete API
        this.deleteAntiPassGate(this.gateInfor.antiPassbackPrev.relationId)
      }
    },
    deleteAntiPassGate (relationId) {
      var vm = this
      vm.$http.delete(Config.RELATION_ANTIPASS_GATE_API + '/' + encodeURIComponent(relationId))
        .then(response => {
          // deleted anti-pass successfully, then call to anti-pass insert API
          if (vm.gateInfor.isAntiPassback === true) {
            // check isAntiPassback = true here because if prev is true but current is false
            this.createAntiPassGate(this.gateId)
          } else {
            vm.gateInfor.antiPassback.relationId = 0
            vm.gateInfor.isAntiPassbackPrev = vm.gateInfor.isAntiPassback
            this.setAntiPassData(vm.gateInfor.antiPassback)
            this.loading = false
            this.message = Config.EDIT_GATE_API_SUCCESS
            this.errorMessageLogs = ''
            window.scrollTo(0, 0)
          }
        })
        .catch((error) => {
          this.message = ''
          this.loading = false
          window.scrollTo(0, 0)
          this.errorMessageLogs = 'アンチパスバックの更新に失敗しました。<br/>再度アンチパスバックの変更をお願いします。'
          console.log(error)
        })
    },
    createAntiPassGate (mainGateId) {
      var vm = this
      const Infor = {
        ownerId: localStorage.ownerId,
        gateIdA: mainGateId,
        gateIdB: vm.gateInfor.antiPassback.gateId,
        mode: vm.gateInfor.antiPassback.mode
      }
      console.log(Infor)
      this.$http.post(Config.RELATION_ANTIPASS_GATE_API, Infor)
        .then(response => {
          this.loading = false
          this.message = Config.EDIT_GATE_API_SUCCESS
          this.errorMessageLogs = ''
          window.scrollTo(0, 0)
          vm.gateInfor.antiPassback.relationId = response.body.relationId
          vm.gateInfor.isAntiPassbackPrev = vm.gateInfor.isAntiPassback
          this.setAntiPassData(vm.gateInfor.antiPassback)
        })
        .catch((error) => {
          this.message = ''
          this.loading = false
          window.scrollTo(0, 0)
          this.errorMessageLogs = 'アンチパスバックの更新に失敗しました。<br/>再度アンチパスバックの変更をお願いします。'
          console.log(error)
        })
    }
  }
}
</script>
<style>
.note-text{
  margin: 10px 0px 0px
}
.detail-gate-edit .profile-info-name{
  width: 400px
}
.float-left{
    float: left;
    padding-left: 12px
  }
  .btn-cus{
    padding: 10px 15px;
    color: #fff
  }
  .btn-right{
    float: right;
  }
  .btn-add,.btn-add:hover{
    background: #007F41
  }
  a.btn-delete,a.btn-delete:hover{
    background: #000!important;
    border-color: #000!important;
    color: #fff!important;
    margin-right: 10px;
    text-decoration: none;
  }
  .form-horizontal .control-label{
    margin-top: 0px
  }
  .col-custom{
    padding-right: 0px!important;
  }
  .iValid{
    padding-top: 2px!important;
  }
  input[type=checkbox].ace.ace-switch+.lbl::before{
    text-indent: 25px!important;
    content: "無効"!important;
  }
  input[type=checkbox].ace.ace-switch:checked+.lbl::before{
    text-indent: 5px!important;
    content: "有効"!important;
  }
  .message{
    position: absolute;
  }
  .form-horizontal .control-label{
    text-align: left;
  }
  #gate-list .modal-body {
    height: 250px;
    overflow-y: auto;
  }
  #gate-list .modal-content {
    width: 768px;
    overflow-y: auto;
  }
  #gate-list .modal-header h3.frofile-title{
    padding-bottom: 10px
  }
  #gate-list .modal-header {
    padding: 10px 15px;
  }
</style>



// WEBPACK FOOTER //
// src/views/gate/GateEdit.vue